// Prompt-free launch window.
// Everyone has FREE premium access through Nov 1, 2026, so the app must not
// show ANY "upgrade / become a founder" prompts, nudges, or modals during this
// window. Countdown banners (Fall / Free-Premium) still show — only the upsell
// CTAs are suppressed. This helper auto-expires, so normal upsells resume after.
export const PROMPT_FREE_UNTIL = Date.UTC(2026, 10, 1, 5, 0, 0); // ~Nov 1 2026, 00:00 ET

export function isPromptFree() {
  try {
    return Date.now() < PROMPT_FREE_UNTIL;
  } catch {
    return true;
  }
}
